import { render, staticRenderFns } from "./FilterList.vue?vue&type=template&id=2dd12d77&scoped=true"
import script from "./FilterList.vue?vue&type=script&lang=ts"
export * from "./FilterList.vue?vue&type=script&lang=ts"
import style0 from "./FilterList.vue?vue&type=style&index=0&id=2dd12d77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd12d77",
  null
  
)

export default component.exports